import { Container, Sprite } from 'pixi.js';

import { Shared } from '../App';

export class CharacterIcon extends Container
{
    public bg: Sprite;
    public border: Sprite;
    public image: Sprite;

    constructor()
    {
        super();

        this.bg = new Sprite();
        this.bg.anchor.set(0.5);
        this.bg.texture = Shared.assets.getTexture('item-holder-large');
        this.addChild(this.bg);

        this.border = new Sprite();
        this.border.anchor.set(0.5);
        this.border.texture = Shared.assets.getTexture('item-holder-large-border');
        this.addChild(this.border);

        this.image = new Sprite();
        this.image.anchor.set(0.5);
        this.addChild(this.image);
    }

    public setCharacter(id: string, scale = 1): void
    {
        this.bg.scale.set(scale);
        this.border.scale.set(scale);
        this.image.texture = Shared.assets.getTexture(`character-${id}`);
        this.image.scale.set(scale * 1.21);
    }
}
